import React, { useState, useEffect } from "react";
import "./Projects.css";
import companyResume from "../../assets/RAES_Company_Resume.pdf";

const importAll = (r) => r.keys().map(r);

const Projects = () => {
  // dynamically import all images in the folder
  const images = importAll(
    require.context("../../assets/carousel-images", false, /\.(png|jpe?g|svg)$/)
  );

  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 3000); // change 3000 to adjust speed (milliseconds)

    return () => clearInterval(interval); // cleanup on unmount
  }, [currentIndex]); // depends on currentIndex

  return (
    <section className="projects-section">
      <h3 style={{color:"#0D3B66"}}>Projects</h3>
      <div className="carousel">
        <button className="nav prev" onClick={prevSlide}>
          &#10094;
        </button>

        <img src={images[currentIndex]} alt={`Project ${currentIndex + 1}`} />

        <button className="nav next" onClick={nextSlide}>
          &#10095;
        </button>
      </div>
      <a
        href={companyResume}
        download
        className="download-btn"
      >
        Download Our Company Profile
      </a>
    </section>
  );
};

export default Projects;
